<template>
  <div class="my-dialog">
    <el-dialog
      title="修改个人信息"
      :visible.sync="dialogVisible"
      :show-close="false"
      top="30vh"
      :close-on-click-modal="false"
    >
      <template v-slot:title>
        <div class="icon-title">
          <img :src="icon" alt="个人信息" class="icon" />
          <span class="title">{{ title }}</span>
        </div>
      </template>
      <slot></slot>
      <template v-slot:footer>
        <button class="tool-button confirm" @click="handleComfirm">
          {{ confirmButtonText }}
        </button>
        <button class="tool-button" @click="handleCancel">
          {{ cancelButtonText }}
        </button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MyDialog',
  props: {
    title: {
      type: String,
      default: '修改个人信息'
    },
    icon: {
      type: String,
      default: require('@/assets/images/userPage/user.png')
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    }
  },
  data () {
    return {
      dialogVisible: false,
      fun: null,
      canclefun: null
    }
  },
  methods: {
    open (fun, cancelFun) {
      this.fun = fun
      this.canclefun = cancelFun
      this.dialogVisible = true
    },
    close () {
      this.dialogVisible = false
    },
    handleComfirm () {
      if (this.fun) {
        this.fun()
      }
      this.$emit('confirm')
      this.close()
    },
    handleCancel () {
      if (this.canclefun) {
        this.canclefun()
      }
      this.$emit('cancel')
      this.close()
    },
    changeInfo () {
      console.log('--')
    }
  }
}
</script>

<style scoped>
.my-dialog >>> .el-dialog__footer {
  text-align: center;
}

.my-dialog >>> .el-dialog__header {
  text-align: left;
  padding-top: 0;
}

.my-dialog >>> .el-dialog__body {
  padding: 0;
  padding-left: 16px;
}

.my-dialog >>> .el-dialog {
  margin-top: 40vh !important;
  width: 300px;
}

.tool-button {
  width: 90px;
  height: 35px;
  border: 1px solid #9e5c1d;
  background-color: #fff;
  margin: 0 9px;
  cursor: pointer;
}

.tool-button.confirm {
  background-color: #9e5c1d;
  color: #fff;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.my-dialog >>> .el-input__inner {
  height: 40px;
  border: 1px solid #634c37;
  border-radius: 0;
  color: #634c37;
  font-size: 14px;
  padding: 0 25px;
}

.my-dialog >>> .el-input__inner:hover {
  border: 1px solid #9e5c1d;
}

.my-dialog >>> .el-input__inner:focus {
  border: 1px solid #9e5c1d;
}
</style>



// WEBPACK FOOTER //
// src/components/MyDialog.vue